import React from 'react';
import { resolveLevel, hasValidScore } from '../../../../assessment/healthSpanScore.utils';

const NO_DATA_COLOR = '#A1A1A1';

const CategoryScoreGrid = ({ categories, categoryScores, categoryMetadata, scoreDetails, onCategoryClick }) => (
  <div className='grid-view'>
    {categories.map((category) => {
      const score = categoryScores[category.id];
      const metadata = categoryMetadata?.[category.id] || null;
      const detail = scoreDetails?.[category.id];
      // Has data = has score_details entry with non-empty sub_categories, or score > 0
      const hasSubData = detail && Object.keys(detail.subCategories || {}).length > 0;
      const hasData = score !== null && score !== undefined && (score > 0 || hasSubData);
      const level = resolveLevel(hasData ? score : null, metadata);
      const displayColor = hasData ? level.barColor : NO_DATA_COLOR;

      return (
        <button
          type='button'
          className='grid-item'
          key={category.id}
          onClick={() => onCategoryClick(category)}
          aria-label={`ดูรายละเอียด ${category.name}`}
        >
          <img className='item-image' src={category.icon} alt={category.shortName} />
          <div className='item-name'>{category.shortName}</div>
          <div className='item-status' style={{ color: displayColor }}>{hasData ? level.statusText : 'ไม่มีข้อมูล'}</div>
          <div className='item-score'>
            <div className='score-value' style={{ color: displayColor }}>{hasData ? score : '-'}</div>
            <div className='score-total'>/{level.maxScore}</div>
          </div>
        </button>
      );
    })}
  </div>
);

export default CategoryScoreGrid;
